import script from "./headerbar.vue?vue&type=script&setup=true&lang=ts"
export * from "./headerbar.vue?vue&type=script&setup=true&lang=ts"

import "./headerbar.vue?vue&type=style&index=0&id=3fbe946f&scoped=true&lang=scss"

import exportComponent from "K:\\VoionContaract\\voion.contaract.clients\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3fbe946f"]])

export default __exports__